function BrandLogo({ size = "header", onClick }) {
  const isFooter = size === "footer";

  return (
    <a
      href="#home"
      onClick={onClick}
      className="group inline-flex items-center gap-3"
      aria-label="BeeVerge home"
    >
      <span
        className={`relative flex shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white shadow-[0_0_24px_rgba(255,255,255,0.18)] transition group-hover:shadow-neon ${
          isFooter ? "h-14 w-14" : "h-11 w-11"
        }`}
      >
        <svg
          viewBox="0 0 64 64"
          role="img"
          aria-hidden="true"
          className={isFooter ? "h-10 w-10 text-black" : "h-8 w-8 text-black"}
        >
          <g fill="none" stroke="currentColor" strokeLinecap="square" strokeWidth="7">
            <path d="M32 6v52" />
            <path d="M6 32h52" />
            <path d="M13.6 13.6l36.8 36.8" />
            <path d="M50.4 13.6 13.6 50.4" />
          </g>
          <circle cx="32" cy="32" r="4.5" fill="currentColor" />
        </svg>
      </span>

      <span
        className={`font-black tracking-tight text-white transition group-hover:text-cyan-100 ${
          isFooter ? "text-3xl" : "text-2xl"
        }`}
      >
        BeeVerge
      </span>
    </a>
  );
}

export default BrandLogo;
